'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _Vue = Vue,
    createApp = _Vue.createApp,
    ref = _Vue.ref,
    defineProps = _Vue.defineProps,
    computed = _Vue.computed,
    watch = _Vue.watch,
    nextTick = _Vue.nextTick,
    onMounted = _Vue.onMounted;


numeral.register('locale', 'no', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    currency: {
        symbol: ''
    }
});

numeral.locale('no');

var app = createApp({
    setup: function setup() {

        // statics
        var termFee = ref(95);
        var registrationFee = ref(1034);
        var establishmentFee = ref(2990);
        var carPriceMax = ref(2000000);
        var repaymentPeriodMax = ref(7);
        var grade1NominalInterestRate = ref(0);
        var grade2NominalInterestRate = ref(0);
        var grade3NominalInterestRate = ref(0);

        // inputs
        var repaymentPeriod = ref(3);
        var carPrice = ref(200000);
        var equity = ref(0);
        var carDecided = ref(null);
        var carRegistrationNumber = ref('');
        var finnCode = ref('');
        var car = ref({
            year: '',
            brand: '',
            model: '',
            regnumber: ''
        });

        var clientName = ref('');
        var clientDateOfBirth = ref('');
        var clientEmail = ref('');
        var clientPhone = ref('');
        var clientAmcarMember = ref(false);
        var clientMemberId = ref('');
        var clientColoaner = ref(false);
        var coloanerName = ref('');
        var coloanerDateOfBirth = ref('');
        var coloanerEmail = ref('');
        var coloanerPhone = ref('');

        // element refs
        var carPriceInput = ref(null);
        var carPriceSlider = ref(null);
        var equityInput = ref(null);
        var equitySlider = ref(null);
        var repaymentPeriodInput = ref(null);
        var repaymentPeriodSlider = ref(null);

        // state
        var currentStep = ref(1);
        var showCarPriceInput = ref(false);
        var showEquityInput = ref(false);
        var showRepaymentPeriodInput = ref(false);
        var carDetailsError = ref(false);

        // sliders
        var carPriceSliderInstance = ref(null);
        var equitySliderInstance = ref(null);
        var repaymentPeriodSliderInstance = ref(null);

        // computed
        var nominalInterestRate = computed(function () {
            if (percentageEquity.value < 20) {
                return grade1NominalInterestRate.value;
            }

            if (percentageEquity.value >= 20 && percentageEquity.value < 35) {
                return grade2NominalInterestRate.value;
            }

            if (percentageEquity.value >= 35) {
                return grade3NominalInterestRate.value;
            }
        });

        var interestRate = computed(function () {
            var plan = getPaymentPlan(loan.value, repaymentPeriod.value, 12, establishmentFee.value, registrationFee.value, termFee.value, nominalInterestRate.value);
            return plan.effectiveInterestRate;
        });
        var repaymentPeriodInMonths = computed(function () {
            return repaymentPeriod.value * 12;
        });
        var loan = computed(function () {
            return Number(carPrice.value) - Number(equity.value);
        });
        var loanTotal = computed(function () {
            return loan.value + establishmentFee.value + registrationFee.value;
        });
        var percentageEquity = computed(function () {
            var result = equity.value / carPrice.value * 100;

            if (isNaN(result)) {
                return 0;
            }

            return result.toFixed();
        });

        var sumPerMonth = computed(function () {
            if (!repaymentPeriod.value) {
                return 0;
            }

            var data = getPaymentPlan(loanTotal.value, repaymentPeriod.value, 12, establishmentFee.value, registrationFee.value, termFee.value, nominalInterestRate.value);
            return Math.abs(Math.round(data.plan[1].sumPayment));
        });

        var isStep1Valid = computed(function () {
            if (carDecided.value === false) {
                return true;
            }

            if (carRegistrationNumber.value.length && carRegistrationNumber.value !== car.value.regnumber) {
                return false;
            }

            return carDecided.value === true && (finnCode.value.length || carRegistrationNumber.value.length);
        });

        var isStep2Valid = computed(function () {
            if (!clientName.value.length || !clientDateOfBirth.value.length || !clientEmail.value.length || !clientPhone.value.length) {
                return false;
            }

            if (clientColoaner.value === true && (!coloanerName.value.length || !coloanerDateOfBirth.value.length || !coloanerEmail.value.length || !coloanerPhone.value.length)) {
                return false;
            }

            if (clientAmcarMember.value === true && !clientMemberId.value.length) {
                return false;
            }

            return true;
        });

        onMounted(function () {
            grade1NominalInterestRate.value = ekGrade1ni;
            grade2NominalInterestRate.value = ekGrade2ni;
            grade3NominalInterestRate.value = ekGrade3ni;

            initCarPriceSlider();
            initEquitySlider();
            initRepaymentPeriodSlider();
        });

        // methods
        var initCarPriceSlider = function initCarPriceSlider() {

            if (carPriceSliderInstance.value) {
                carPriceSliderInstance.value.destroy();
            }

            carPriceSliderInstance.value = noUiSlider.create(carPriceSlider.value, {
                start: 0,
                step: 10000,
                connect: [true, false],
                format: {
                    to: noUiToValueFormatter,
                    from: noUiFromValueFormatter
                },
                range: {
                    'min': 0,
                    'max': carPriceMax.value
                }
            });

            carPriceSliderInstance.value.on('slide', function (val) {
                return carPrice.value = Number(val[0]);
            });
            carPriceSliderInstance.value.on('end', function (val) {
                var value = Number(val[0]);

                if (equity.value > value) {
                    equity.value = value;
                }

                initEquitySlider();
            });
        };

        var initEquitySlider = function initEquitySlider() {

            if (equitySliderInstance.value) {
                equitySliderInstance.value.destroy();
            }

            equitySliderInstance.value = noUiSlider.create(equitySlider.value, {
                start: 0,
                step: 10000,
                connect: [true, false],
                format: {
                    to: noUiToValueFormatter,
                    from: noUiFromValueFormatter
                },
                range: {
                    'min': 0,
                    'max': carPrice.value || carPriceMax.value
                }
            });

            equitySliderInstance.value.set(equity.value);
            equitySliderInstance.value.on('slide', function (val) {
                return equity.value = Number(val[0]);
            });
        };

        var initRepaymentPeriodSlider = function initRepaymentPeriodSlider() {

            if (repaymentPeriodSliderInstance.value) {
                repaymentPeriodSliderInstance.value.destroy();
            }

            repaymentPeriodSliderInstance.value = noUiSlider.create(repaymentPeriodSlider.value, {
                start: 1,
                step: 1,
                connect: [true, false],
                format: {
                    to: noUiToValueFormatter,
                    from: noUiFromValueFormatter
                },
                range: {
                    'min': 0,
                    'max': repaymentPeriodMax.value
                }
            });

            repaymentPeriodSliderInstance.value.set(repaymentPeriod.value);
            repaymentPeriodSliderInstance.value.on('slide', function (val) {
                return repaymentPeriod.value = Number(val[0]);
            });
        };

        var showAndFocusCarPriceInput = async function showAndFocusCarPriceInput() {
            showCarPriceInput.value = true;
            await nextTick();
            carPriceInput.value.focus();
        };

        var showAndFocusEquityInput = async function showAndFocusEquityInput() {
            showEquityInput.value = true;
            await nextTick();
            equityInput.value.focus();
        };

        var showAndFocusRepaymentPeriodInput = async function showAndFocusRepaymentPeriodInput() {
            showRepaymentPeriodInput.value = true;
            await nextTick();
            repaymentPeriodInput.value.focus();
        };

        var onCarPriceInput = function onCarPriceInput(e) {
            var val = Number(carPrice.value.replace(/[^\d]/g, function () {
                return '';
            }));

            if (val > carPriceMax.value) {
                val = carPriceMax.value;
            }

            carPrice.value = val;
            carPriceSliderInstance.value.set(val);
        };

        var onEquityInput = function onEquityInput(e) {
            var value = Number(equity.value.replace(/[^\d]/g, function () {
                return '';
            }));

            if (value > carPrice.value) {
                value = carPrice.value;
            }

            equity.value = value;
            equitySliderInstance.value.set(val);
        };

        var onRepaymentPeriodInput = function onRepaymentPeriodInput(e) {
            var value = isNaN(e.data) ? 1 : Number(e.data);

            if (value > repaymentPeriodMax.value) {
                value = repaymentPeriodMax.value;
            }

            if (value < 1) {
                value = 1;
            }

            repaymentPeriod.value = value;
            repaymentPeriodSliderInstance.value.set(value);
        };

        var noUiToValueFormatter = function noUiToValueFormatter(value) {
            return Number(value).toFixed();
        };

        var noUiFromValueFormatter = function noUiFromValueFormatter(value) {
            return value;
        };

        var displayPrice = function displayPrice(value) {
            var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (isNaN(value) || value === Infinity) {
                return '-';
            }

            if (round) {
                value = Math.round(value);
            }

            return numeral(value).format('0,0[.]00 $');
        };

        var getVehicleData = async function getVehicleData() {
            if (carRegistrationNumber.length < 4) {
                return;
            }

            carDetailsError.value = false;

            try {
                var response = await axios.get('/finansiering/bilinfo?regNr=' + carRegistrationNumber.value);

                var registeredDate = new Date(Date.parse(response.data.registeredDate));

                car.value.model = response.data.model;
                car.value.brand = response.data.brand;
                car.value.year = registeredDate.getFullYear();
                car.value.regnumber = carRegistrationNumber.value;
            } catch (err) {
                car.value.model = '';
                car.value.brand = '';
                car.value.year = '';
                car.value.regnumber = '';

                carDetailsError.value = true;
            }
        };

        var getPaymentPlan = getInterestRateFactory();

        var sendApplication = async function sendApplication() {
            var _data;

            var data = (_data = {
                repaymentPeriod: repaymentPeriod.value,
                carPrice: carPrice.value,
                equity: equity.value,
                carDecided: carDecided.value,
                carRegistrationNumber: carRegistrationNumber.value,
                finnCode: finnCode.value,
                car: car.value,
                clientColoaner: clientColoaner.value,
                clientName: clientName.value,
                clientDateOfBirth: clientDateOfBirth.value,
                clientEmail: clientEmail.value,
                clientPhone: clientPhone.value,
                clientAmcarMember: clientAmcarMember.value,
                clientMemberId: clientMemberId.value
            }, _defineProperty(_data, 'clientColoaner', clientColoaner.value), _defineProperty(_data, 'coloanerName', coloanerName.value), _defineProperty(_data, 'coloanerDateOfBirth', coloanerDateOfBirth.value), _defineProperty(_data, 'coloanerEmail', coloanerEmail.value), _defineProperty(_data, 'coloanerPhone', coloanerPhone.value), _defineProperty(_data, 'loanAmount', loan.value), _data);

            try {
                var response = await axios.post('/finansiering/billan', data);

                currentStep.value++;
            } catch (err) {
                console.log(err);
            }
        };

        // return values to template
        return {
            // statics
            termFee: termFee,
            registrationFee: registrationFee,
            establishmentFee: establishmentFee,
            carPriceMax: carPriceMax,
            repaymentPeriodMax: repaymentPeriodMax,

            // inputs
            repaymentPeriod: repaymentPeriod,
            carPrice: carPrice,
            equity: equity,
            carDecided: carDecided,
            carRegistrationNumber: carRegistrationNumber,
            finnCode: finnCode,
            car: car,
            clientColoaner: clientColoaner,
            clientName: clientName,
            clientDateOfBirth: clientDateOfBirth,
            clientEmail: clientEmail,
            clientPhone: clientPhone,
            clientAmcarMember: clientAmcarMember,
            clientMemberId: clientMemberId,
            coloanerName: coloanerName,
            coloanerDateOfBirth: coloanerDateOfBirth,
            coloanerEmail: coloanerEmail,
            coloanerPhone: coloanerPhone,

            // element refs
            carPriceInput: carPriceInput,
            carPriceSlider: carPriceSlider,
            equityInput: equityInput,
            equitySlider: equitySlider,
            repaymentPeriodInput: repaymentPeriodInput,
            repaymentPeriodSlider: repaymentPeriodSlider,

            // state
            currentStep: currentStep,
            showCarPriceInput: showCarPriceInput,
            showEquityInput: showEquityInput,
            showRepaymentPeriodInput: showRepaymentPeriodInput,
            carDetailsError: carDetailsError,

            // sliders
            carPriceSliderInstance: carPriceSliderInstance,
            equitySliderInstance: equitySliderInstance,
            repaymentPeriodSliderInstance: repaymentPeriodSliderInstance,

            // computed
            nominalInterestRate: nominalInterestRate,
            interestRate: interestRate,
            repaymentPeriodInMonths: repaymentPeriodInMonths,
            loan: loan,
            loanTotal: loanTotal,
            percentageEquity: percentageEquity,
            sumPerMonth: sumPerMonth,
            isStep1Valid: isStep1Valid,
            isStep2Valid: isStep2Valid,

            // methods
            showAndFocusCarPriceInput: showAndFocusCarPriceInput,
            showAndFocusEquityInput: showAndFocusEquityInput,
            showAndFocusRepaymentPeriodInput: showAndFocusRepaymentPeriodInput,
            onCarPriceInput: onCarPriceInput,
            onEquityInput: onEquityInput,
            onRepaymentPeriodInput: onRepaymentPeriodInput,
            displayPrice: displayPrice,
            getVehicleData: getVehicleData,
            sendApplication: sendApplication,

            grade1NominalInterestRate: grade1NominalInterestRate,
            grade2NominalInterestRate: grade2NominalInterestRate,
            grade3NominalInterestRate: grade3NominalInterestRate
        };
    }
}).mount('#car-loan-app');

function getInterestRateFactory() {
    var effectiveInterestRateResult = 0;
    var iteration = 0;
    var oldInterestRate = 0;
    var difference = 0;
    var positive = 0;
    var negative = 0;

    var getInterestRate = function getInterestRate(paymentArray, interestRate) {
        iteration++;

        var nvp = 0;
        var calcArray = interestRate / 100;

        if (iteration > 200) {
            return false;
        }

        nvp = paymentArray[0];

        for (i = 1; i < paymentArray.length; i++) {
            nvp += paymentArray[i] / Math.pow(1 + calcArray, i);
        }

        if (positive === 0 || negative === 0) {
            if (nvp < 0) {
                negative++;
                oldInterestRate = interestRate;
                interestRate += 1;
            } else {
                positive++;
                oldInterestRate = interestRate;
                interestRate -= 1;
            }

            getInterestRate(paymentArray, interestRate);
        } else {
            difference = Math.abs(oldInterestRate - interestRate);

            oldInterestRate = interestRate;

            if (Math.floor(nvp) == 0 || Math.ceil(nvp) == 0) {
                calcArray = calcArray * 100;
                calcArray = calcArray * 100 / 100;
                effectiveInterestRateResult = calcArray;
            } else if (nvp > 0) {
                interestRate -= difference / 2;
                getInterestRate(paymentArray, interestRate);
            } else {
                interestRate += difference / 2;
                getInterestRate(paymentArray, interestRate);
            }
        }
    };

    var getAnnuity = function getAnnuity(i, n, p) {
        return i * p * Math.pow(1 + i, n) / (1 - Math.pow(1 + i, n));
    };

    return function getResult(loanAmount, paymentYear, installmentsPerYear, estabFee, mortLoanFee, termFee, interestRate) {
        var sumPayment = [];
        var resultArray = [];
        var calculationArray = [];
        var effectiveInterestRate = 0;
        var initialRateOnePaymentPeriod = interestRate / installmentsPerYear;
        var calculationYear = 1;
        var calculationPeriod = 1;

        effectiveInterestRateResult = 0;
        iteration = 0;
        oldInterestRate = 0;
        difference = 0;
        positive = 0;
        negative = 0;

        var annuity = getAnnuity(interestRate / installmentsPerYear / 100, installmentsPerYear * paymentYear, loanAmount);

        calculationArray["year"] = 1;
        calculationArray["period"] = 0;
        calculationArray["installment"] = loanAmount;
        calculationArray["fees"] = parseFloat("-" + (estabFee + mortLoanFee));
        calculationArray["interest"] = 0;
        calculationArray["sumPayment"] = calculationArray["installment"] + calculationArray["interest"] + calculationArray["fees"];
        calculationArray["remainingDebt"] = parseFloat("-" + loanAmount);
        resultArray[0] = calculationArray;

        for (var _i = 1; _i <= installmentsPerYear * paymentYear; _i++) {
            calculationArray = [];
            calculationArray["year"] = calculationYear;
            calculationArray["period"] = calculationPeriod;

            if (calculationPeriod == installmentsPerYear) {
                calculationYear++;
                calculationPeriod = 1;
            } else {
                calculationPeriod++;
            }

            calculationArray["interest"] = resultArray[_i - 1]["remainingDebt"] * initialRateOnePaymentPeriod / 100;
            calculationArray["installment"] = annuity - calculationArray["interest"];
            calculationArray["fees"] = parseFloat("-" + termFee);
            calculationArray["sumPayment"] = calculationArray["installment"] + calculationArray["interest"] + calculationArray["fees"];
            calculationArray["remainingDebt"] = (resultArray[_i - 1]["remainingDebt"] - calculationArray["installment"]).toFixed(10);

            resultArray[_i] = calculationArray;
        }

        for (i = 0; i < resultArray.length; i++) {
            sumPayment[i] = resultArray[i]["sumPayment"];
        }

        getInterestRate(sumPayment, 1);

        effectiveInterestRateResult = effectiveInterestRateResult / 100;

        effectiveInterestRate = (Math.pow(1 + effectiveInterestRateResult, installmentsPerYear) - 1) * 100;
        effectiveInterestRate = Math.round(effectiveInterestRate * 100) / 100;

        return {
            effectiveInterestRate: effectiveInterestRate,
            plan: resultArray
        };
    };
}